import { trigger, state, style, animate, transition } from '@angular/animations';
import { Component, HostListener } from '@angular/core';

@Component({
  selector: 'dram-slides',
  templateUrl: './dram-slides.component.html',
  styleUrls: ['./dram-slides.component.css'],
  animations: [
    trigger('fadeImg', [
      state('visible', style({ opacity: 1 })),
      state('hidden', style({ opacity: 0 })),
      transition('visible <=> hidden', animate('0.5s ease-in')),
    ]),
    trigger('fadeText', [
      state('visible', style({ opacity: 1 })),
      state('hidden', style({ opacity: 0 })),
      transition('visible <=> hidden', animate('0.5s ease-in')),
    ])
  ]
})
export class DramSlidesComponent {
  images = {
    greenLines: 'assets/images/green-lines.svg',
  };
  icons = {
    buttonCircle: 'assets/icons/button-circle.svg',
    sphere1: 'assets/images/sphere-1.png',
  };

  slides = [
    { src: 'assets/images/slide-maquinaria.jpg', title: 'maquinaria' },
    { src: 'assets/images/slide-instalacion.jpg', title: 'instalacion' },
    { src: 'assets/images/slide-insumos.jpg', title: 'insumos' },
    { src: 'assets/images/slide-nuevo-personal.jpg', title: 'nuevoPersonal' }
  ];

  currentIndex = 0;
  nextIndex = 0;
  isActive = this.slides[0].title;
  currentImgState: 'visible' | 'hidden' = 'visible';
  nextImgState: 'visible' | 'hidden' = 'hidden';
  textState: 'visible' | 'hidden' = 'visible';
  isTransitioning = false;
  intervalId: any;

  ngOnInit() {
    this.startAutoSlide();
  }

  startAutoSlide() {
    this.intervalId = setInterval(() => {
      this.fadeToNextSlide();
    }, 6000);
  }

  fadeToNextSlide() {
    if (this.isTransitioning) return;
    this.isTransitioning = true;
    this.nextIndex = (this.currentIndex + 1) % this.slides.length;
    this.nextImgState = 'visible';
    this.currentImgState = 'hidden';
    this.textState = 'hidden';

    setTimeout(() => {
      this.currentIndex = this.nextIndex;
      this.isActive = this.slides[this.currentIndex].title;
      // Espera un tick para que el nuevo texto se cree con textState='hidden'
      setTimeout(() => {
        this.textState = 'visible';
        this.currentImgState = 'visible';
        this.nextImgState = 'hidden';
        this.isTransitioning = false;
      }, 10); // pequeño delay para animación de entrada
    }, 350);
  }

  setActiveSlide(title: string): void {
    if (this.isTransitioning || this.isActive === title) return;
    this.isTransitioning = true;
    this.nextIndex = this.slides.findIndex(s => s.title === title);
    this.nextImgState = 'visible';
    this.currentImgState = 'hidden';
    this.textState = 'hidden';
    this.isActive = title;

    setTimeout(() => {
      this.currentIndex = this.nextIndex;
      setTimeout(() => {
        this.textState = 'visible';
        this.currentImgState = 'visible';
        this.nextImgState = 'hidden';
        this.isTransitioning = false;
      }, 10); // pequeño delay para animación de entrada
    }, 350);

    clearInterval(this.intervalId);
    this.startAutoSlide();
  }

  get currentSlide() {
    return this.slides[this.currentIndex];
  }
  get nextSlide() {
    return this.slides[this.nextIndex];
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const scrollY = window.scrollY;
    const sphere6 = document.querySelector('.hero-sphere-6') as HTMLElement;
    if (sphere6) sphere6.style.transform = `translateY(${scrollY * 0.25}px)`;
  }
}
